<div
  class="calculation-container calculationPage calculationPageMobilePremiumBlock"
>
  <div class="calculation-header">
    <h1
      class="calculation-title defaultBackgroundColor"
      appConfigSettingsTitle
      appConfigSettingsBackground
    >
      {{ "ApplicationPage.GG_Title" | translate }}
    </h1>
  </div>
  <div class="navigation">
    <app-navigation-component
      (navigationStepsReady)="setActiveStep()"
      [productType]="productType"
    ></app-navigation-component>
  </div>
  <div class="calculation-sub-title calculation-sub-title-mobile">
    <h4 appConfigSettingsSecondTitle>
      {{ "Calculation.SecondTitle" | translate }}
    </h4>
  </div>
  <div class="columns column1">
    <div class="calculation-sub-title">
        <h4 appConfigSettingsSecondTitle>
          {{ "Calculation.SecondTitle" | translate }}
        </h4>
    </div>
    <form [formGroup]="form">
      <div>
        <app-autocomplete-input
          class="full-width"
          appConfigSettingsInput
          placeholder="Insured.Occupation"
          [form]="form"
          [control]="form.get('occupation')"
          [dataSource]="selectOccupationsList"
          showPlaceholder="false"
          [isDefaultValueSetAfterOptionListChanged]="false"
          (change)="occupationFieldChange()"
          additionalInfoInsurer="Insured.OccupationAdditionalInfo"
        ></app-autocomplete-input>
        <mat-error *ngIf="isWithoutOwnLaborError" class="error-message">
          <ng-container>
            {{ 'Common.OccupationWithoutOwnLabor' | translate }}
          </ng-container>
        </mat-error>
      </div>
      <div>
        <app-date-input
          appConfigSettingsInput
          class="full-width"
          placeholder="Insured.DateOfBirth_GG"
          [control]="form.get('dateOfBirth')"
          [form]="form"
          datePlaceholder="CalculationInsurer.DateOfBirthPlaceholder"
          [dateMask]="dateMaskFormat"
          (change)="updateDurationOptions()"
          required
        ></app-date-input>
      </div>
      <div>
        <app-text-input
          appConfigSettingsInput
          placeholder="Insured.MonthlyAmount"
          [control]="form.get('sumAssured')"
          [form]="form"
          showPlaceholder="false"
          inputMask="separator.0"
          [thousandSeparator]="thousandSeparator"
          prefix="€ "
          additionalInfoInsurer="Calculation.SumAssuredAdditionalInfo"
          (toggleCalculator)="toggleCalculator()"
          isCalculatorShown="true"
        ></app-text-input>
      </div>
      <div>
        <app-toggle-input
          [groupBy2InLine]="true"
          placeholder="CalculationInsurer.BenefitDuration"
          freeText="CalculationInsurer.BenefitDurationExplanation"
          [form]="form"
          [optionsList]="durationList"
          [control]="form.get('claimDuration')"
          appConfigSettingsParagraph
          required
          isRequiredMessageKey="Calculation.RequiredField"
        ></app-toggle-input>
      </div>
      <div>
        <app-select-box
          class="yearInput"
          placeholder="Insured.StartDate"
          [form]="form"
          [control]="form.get('dateOfCommencement')"
          [optionsList]="datesArray"
          required
          isRequiredMessageKey="Calculation.RequiredField"
          [textColor]="configSettings.inputColor"
          [inputColor]="configSettings.inputColor"
          [fontFamily]="FontTypeEnum[configSettings.fontType]"
          [backgroundHoverColor]="configSettings.backgroundColor"
          [backgroundHoverTextColor]="configSettings.backgroundTextColor"
        ></app-select-box>
      </div>
      <div class="buttons-control-container">
        <button
          type="button"
          appConfigSettingsPrimaryButton
          class="save-btn primary"
          color="primary"
          (click)="handleSubmitCalculate()"
        >
          {{ buttonTitle | translate }}
        </button>
      </div>
    </form>
  </div>
  <div
    class="columns column2"
    [ngClass]="{'show': isSecondColumnShownForMobile}"
  >
    <ng-container *ngIf="calculationExist">
      <app-premium-block
        [isMobile]="true"
        [isStatementsAgreed]="false"
        [isShowCalculatePremiumText]="true"
        [checkIsPremiumsCalculated]="calculationExist"
        (downloadQuote)="downloadQuote()"
        [productType]="productType"
      ></app-premium-block>
    </ng-container>
    <app-notification-block
      [notification]="this.notificationEvent"
      appConfigSettingsParagraph
    ></app-notification-block>
  </div>
</div>

